import { useFetch } from '../useFetch/index'
import { useEffect, useState } from 'react'
import type { IAppInfo } from '@ztechapps/common.contract'

export const useAppInfo = (): { loading: boolean } & IAppInfo => {
  const [fetchNow, { loading }] = useFetch('/api/app-info', { method: 'GET' })
  const [appInfo, setAppInfo] = useState<IAppInfo>(null)

  useEffect(() => {
    fetchNow().then((result: IAppInfo) => {
      setAppInfo(result)
    })
    // fetchNow intentionally excluded: useFetch returns a new function every render (not memoized),
    // so including it would re-fetch app-info and setAppInfo (a new object each time) on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    ...appInfo,
    loading,
  }
}
